import React from 'react';

import { GetPurchaseInvoiceExtendedDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import numberFormatter from '../../../common/numberFormatter';
import CopyButton from '../../../common/components/CopyButton/CopyButton';
import { useTranslation } from '../../../common/hooks/useTranslation';

import { SumData } from './purchaseInvoicePositionsGridUtils';

interface PurchaseInvoiceEstimateItemPositionsGridProps {
  extendedPurchaseInvoice?: GetPurchaseInvoiceExtendedDto;
  sumData: SumData;
}

export const PurchaseInvoiceEstimateItemPositionsGridSum: React.FC<
  PurchaseInvoiceEstimateItemPositionsGridProps
> = props => {
  const { t, tk } = useTranslation('fvzLng');
  const {
    maxSum,
    notAssignedSum,
    purchaseNetTotalSum,
    amountSum,
    unsettledAmount,
  } = props.sumData;
  const isTV = props.extendedPurchaseInvoice?.tv;

  return (
    <>
      <tr>
        <td colSpan={2} className="bold">
          {t(tk.common.sumUpperCase)}:
        </td>
        <td colSpan={isTV ? 3 : 2} />
        <td className="bold amounts-align-right">
          {numberFormatter(purchaseNetTotalSum, true)}
        </td>
        <td className="bold amounts-align-right">
          {numberFormatter(notAssignedSum, true)}
        </td>
        <td />
        <td className="bold">{numberFormatter(amountSum, true)}</td>
      </tr>
      <tr>
        <td colSpan={isTV ? 8 : 7} className="bold">
          {t(tk.finance.invoiceAmountUppercase)}:
        </td>
        <td className="bold">{numberFormatter(maxSum, true)}</td>
      </tr>
      <tr>
        <td colSpan={isTV ? 8 : 7} className="bold align-middle">
          {t(tk.finance.unsettledAmountUppercase)}:
        </td>
        <td className="bold">
          {numberFormatter(unsettledAmount, true)}
          <CopyButton value={numberFormatter(unsettledAmount)} />
        </td>
      </tr>
    </>
  );
};
